import { inject } from 'vue'

export function useModal() {
    const ModalStore = inject('ModalStore')
    // console.log
    const modal = ModalStore.methods.getModalController()
    return modal
}